import {
  ModalCreditSuccess,
  ContentContainer,
  ButtonsContainer,
  ConfirmButton,
  CloseButton,
  MainInfo,
  ComplementaryInfo,
  Success,
  Headers
} from './creditWithdrawSuccess.styles';
import { useState, useEffect } from 'react';
import { Button } from 'src/utilities/UILibrary/UI/Button/Button';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { API } from 'aws-amplify';
import { environment, url } from 'src/environments';
import { useSelector } from 'react-redux';
import { getCreditInfo } from 'src/graphql/customized_queries';
import getCurrentDate from 'src/functions/getCurrentDate';
export default function CreditPaymentModal({
  showModalCreditSuccess,
  closeModal,
  campaignData,
  personalInformation,
  bankInformation
}) {
  //PARA DOBLE FACTOR DE AUT
  const [showInput, setShowInput] = useState(false);
  const [messageId, setMessageId] = useState();
  const [otp, setOtp] = useState('');
  const [successText, setSuccessText] = useState(false);

  const saldoDisponible = personalInformation?.data?.getApplicant?.STP?.recursosDisponibles;
  const saldoDisponibleNum = parseFloat(saldoDisponible);
  const [tiie, setTiie] = useState(0);
  const [tasaInteresAdicionalPorcentaje, setTasaInteresAdicionalPorcentaje] = useState(0);
  const user = useSelector((state) => state.user.currentUser);
  function formatCurrency(amount) {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN'
    }).format(amount);
  }
  //JALAR TIIE E INTEREST RATE
  useEffect(() => {
    axios
      .get(`${url}/${environment}/admin/get-tiie`)
      .then((s) => {
        const parsedData = JSON.parse(s.data.body);
        setTiie(Number(parsedData.TIIE));
      })
      .catch((error) => error);
  }, []);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const { data } = await API.graphql({
          query: getCreditInfo,
          variables: { applicantId: user.id }
        });
        setTasaInteresAdicionalPorcentaje(Number(data.getCreditAnalysis.interestRateApplicant));
      } catch (error) {
        console.error(error);
      }
    };
    fetchUserData();
  }, []);
  //
  function getElapsedDays(date) {
    const currentDate = new Date();
    const startDate = new Date(date);
    const differenceInTime = currentDate.getTime() - startDate.getTime();
    const differenceInDays = Math.floor(differenceInTime / (1000 * 3600 * 24));
    return differenceInDays >= 0 ? differenceInDays : null;
  }

  const plazoCreditoFinal = getElapsedDays(campaignData?.signDate);
  const updateCampaign = {
    type: 'update_campaign_money_related',
    input: {
      paymentDateFinal: getCurrentDate(),
      plazoCreditoFinal: plazoCreditoFinal,
      interesCreditoPesosFinal:
        ((tiie + tasaInteresAdicionalPorcentaje) / 360) *
        plazoCreditoFinal *
        campaignData?.montoTransferencia,
      IVAinteresCreditoPesosFinal:
        ((tiie + tasaInteresAdicionalPorcentaje) / 360) *
        plazoCreditoFinal *
        campaignData?.montoTransferencia *
        0.16,
      interesesCreditoPesosConIVAFinal:
        ((tiie + tasaInteresAdicionalPorcentaje) / 360) *
          plazoCreditoFinal *
          campaignData?.montoTransferencia +
        ((tiie + tasaInteresAdicionalPorcentaje) / 360) *
          plazoCreditoFinal *
          campaignData?.montoTransferencia *
          0.16
    }
  };
  const montoPorLiquidar =
    campaignData?.collectedAmount + updateCampaign?.input?.interesCreditoPesosFinal;
  const isMontoGreater = montoPorLiquidar > saldoDisponibleNum;

  const handleSendEmail = () => {
    const input = {
      id: user.id,
      typeOfUser: 'applicant',
      typeMessage: 'withdrawMoneyCampaign',
      email: user.email,
      timestamp: Date.now()
    };
    axios
      .post(`${url}/${environment}/admin/send-otp-to-email`, input)
      .then((response) => {
        const parsedBody = JSON.parse(response.data.body);
        setMessageId(parsedBody.messageId);
        setShowInput(true);
      })
      .catch((error) => {
        console.error(error);
      });
    setShowInput(true);
  };

  const onConfirm = async () => {
    const input = {
      id: user.id,
      messageId: messageId,
      code: otp,
      timestamp: Date.now(),
      typeOfUser: 'investor'
    };
    // try {
    const validationCode = await axios.post(
      `${url}/${environment}/admin/email/validate-otp`,
      input
    );
    const parsedBody = JSON.parse(validationCode.data.body);
    if (!parsedBody.isVerified) {
      return;
    }
    //JWT agregarlo en este endpoint
    const stpBody = {
      campaignId: campaignData?.id
    };
    const config = {
      headers: {
        apiKey: `${process.env.REACT_APP_APIKEY_STP}`,
        'Content-Type': 'application/json'
      }
    };
    try {
      const stp = await axios.put(
        `${process.env.REACT_APP_STPURL_FINSPHERA}/finish-complete`,
        stpBody,
        config
      );
    } catch (error) {
      console.error(error);
    }
    try {
      await axios.post(`${url}/${environment}/admin/dynamo/update`, updateCampaign);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <ModalCreditSuccess showModalCreditSuccess={showModalCreditSuccess}>
      {!successText ? (
        <ContentContainer>
          <Headers>
            <div></div>
            <figure onClick={closeModal}>
              <img
                src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/icon_modal_close.png`}
                alt="ícono para cerrar la ventana"
              />
            </figure>
          </Headers>
          <h2>
            ¡Estás apunto de realizar el pago del crédito que tienes vigente con{' '}
            <span>FINSPHERA!</span>
          </h2>
          <MainInfo>
            <div>
              <h3>Nombre de campaña:</h3>
              <p> {campaignData?.nombreCampania ? campaignData?.nombreCampania : '-'} </p>
            </div>
            <div>
              <h3>Monto del crédito:</h3>
              <p>
                {campaignData?.collectedAmount
                  ? formatCurrency(campaignData?.collectedAmount)
                  : '-'}
              </p>
            </div>
            <div>
              <h3>Monto por liquidar:</h3>
              <p>{formatCurrency(montoPorLiquidar)}</p>
            </div>
            <div>
              <h3>Plazo del crédito:</h3>
              <p>{campaignData?.plazoCredito} días</p>
            </div>
            <div>
              <h3>Días transcurridos:</h3>
              <p>{plazoCreditoFinal}</p>
            </div>
          </MainInfo>
          <ComplementaryInfo>
            <div>
              <h3>Intereses generados hasta hoy:</h3>
              <p>
                {updateCampaign?.input?.interesCreditoPesosFinal
                  ? formatCurrency(updateCampaign?.input?.interesCreditoPesosFinal)
                  : '-'}
              </p>
            </div>
            <div>
              <h3>IVA de los intereses generados:</h3>
              <p>
                {updateCampaign?.input?.IVAinteresCreditoPesosFinal
                  ? formatCurrency(updateCampaign?.input?.IVAinteresCreditoPesosFinal)
                  : '-'}
              </p>
            </div>
            <div>
              <h3>Intereses + IVA:</h3>
              <p>
                {updateCampaign?.input?.interesesCreditoPesosConIVAFinal
                  ? formatCurrency(updateCampaign?.input?.interesesCreditoPesosConIVAFinal)
                  : '-'}
              </p>
            </div>
          </ComplementaryInfo>
          {showInput ? (
            <ButtonsContainer>
              <p>Ingresa el código que enviamos a tu correo:</p>
              <input
                type="text"
                value={otp}
                onChange={(e) => {
                  setOtp(e.target.value);
                }}
              />
              <ConfirmButton size="small" onClick={onConfirm}>
                Confirmar código
              </ConfirmButton>
            </ButtonsContainer>
          ) : (
            <ButtonsContainer>
              {isMontoGreater && (
                <p>
                  No puedes realizar el pago ya que el monto que tienes por liquidar supera el saldo
                  disponible en tu cuenta.
                </p>
              )}
              <ConfirmButton disabled={isMontoGreater} onClick={handleSendEmail}>
                Aceptar
              </ConfirmButton>
            </ButtonsContainer>
          )}
        </ContentContainer>
      ) : (
        <Success>
          <figure>
            <img
              src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/icon_modal_success.png`}
              alt="icono de correo electrónico"
            />
          </figure>
          <h2>¡Tu pago se ha realizado de forma exitosa!</h2>
          <p>
            Si tienes alguna duda respecto a esta operación, no dudes en contactar al equipo de
            Finsphera.
          </p>
          <Button onClick={closeModal}>Cerrar</Button>
        </Success>
      )}
    </ModalCreditSuccess>
  );
}
